/** Convertit une durée affichée ("1 h 58", "42 min") en minutes. */
export function durationMinutes(duration?: string): number {
  if (!duration) return 0;
  const h = /(\d+)\s*h/.exec(duration);
  const m = /(\d+)\s*min/.exec(duration);
  const hm = /h\s*(\d+)/.exec(duration);
  return (h ? Number(h[1]) * 60 : 0) + (m ? Number(m[1]) : hm ? Number(hm[1]) : 0);
}